@if (!!globalContent && globalContent.length > 0) {
  <section class="wide page-spacing">
    <h4 [innerHTML]="globalContent"></h4>
  </section>
}
<section class="wide page-spacing">
  <div class="dekra-flex">
    <img class="image" alt="Kostentool" src="assets/Kostentool.jpg" (click)="openCostTool()"/>
    <div class="landing-page-section">
      <h2 class="dekra-margin-left dekra-green--themed">{{ 'BUI.COST_TOOL.TITLE'|translate }}</h2>
      @if (!!costToolContent && costToolContent.length > 0) {
        <div class="dekra-margin-left dekra-text--small" [innerHTML]="costToolContent"></div>
      }
      <dekra-button [displayStyle]="DisplayStyle.TEXT" [color]="Color.GREEN" (click)="openCostTool()">
        <dekra-icon name="chevron-right" slot="icon"></dekra-icon>
        {{ 'BUI.COST_TOOL.OPEN'|translate }}
      </dekra-button>
    </div>
  </div>
</section>
<section class="wide page-spacing dekra-padding-bottom">
  <div class="dekra-flex">
    <img class="image" alt="Berichtsgenerator" src="assets/Berichtsgenerator.jpg" (click)="openReportGenerator()"/>
    <div class="landing-page-section">
      <h2 class="dekra-margin-left dekra-green--themed">{{ 'BUI.REPORT_GENERATOR.TITLE'|translate }}</h2>
      @if (!!reportGeneratorContent && reportGeneratorContent.length > 0) {
        <div class="dekra-margin-left dekra-text--small" [innerHTML]="reportGeneratorContent"></div>
      }
      <dekra-button [displayStyle]="DisplayStyle.TEXT" [color]="Color.GREEN" (click)="openReportGenerator()">
        <dekra-icon name="chevron-right" slot="icon"></dekra-icon>
        {{ 'BUI.REPORT_GENERATOR.OPEN'|translate }}
      </dekra-button>
    </div>
  </div>
</section>
